import React from 'react';
import PropTypes from 'prop-types';


const timelineIconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  style: PropTypes.object,
};

const timelineIconDefaultProps = {
  size: 10,
  fill: '#000',
  style: {},
};

const Circle = ({ size, fill, style }) => (
  <svg preserveAspectRatio="xMidYMid meet" width={size} height={size} style={style} viewBox="0 0 10 10">
    <circle cx="5" cy="5" r="5" fill={fill} />
  </svg>
);
Circle.propTypes = timelineIconPropTypes;
Circle.defaultProps = timelineIconDefaultProps;

const Diamond = ({ size, fill, style }) => (
  <svg preserveAspectRatio="xMidYMid meet" width={size} height={size} style={style} viewBox="0 0 10 10">
    <path fill={fill} d="M-.005 5l4.999-5 5 5-5 5z" />
  </svg>
);
Diamond.propTypes = timelineIconPropTypes;
Diamond.defaultProps = timelineIconDefaultProps;

const Square = ({ size, fill, style }) => (
  <svg preserveAspectRatio="xMidYMid meet" width={size} height={size} style={style} viewBox="0 0 10 10">
    <path fill={fill} d="M0 0h10v10H0z" />
  </svg>
);
Square.propTypes = timelineIconPropTypes;
Square.defaultProps = timelineIconDefaultProps;

const Star = ({ size, fill, style }) => (
  <svg preserveAspectRatio="xMidYMid meet" width={size} height={size} style={style} viewBox="0 0 10 10">
    <path fill={fill} d="M5 0l1.77 3.23L10 5 6.77 6.77 5 10 3.23 6.77 0 5l3.23-1.77L5 0z" />
  </svg>
);
Star.propTypes = timelineIconPropTypes;
Star.defaultProps = timelineIconDefaultProps;

const Triangle = ({ size, fill, style }) => (
  <svg preserveAspectRatio="xMidYMid meet" width={size} height={size} style={style} viewBox="0 0 10 8">
    <path fill={fill} d="M5 0L0 8h10L5 0z" />
  </svg>
);
Triangle.propTypes = timelineIconPropTypes;
Triangle.defaultProps = timelineIconDefaultProps;

export {
  Triangle,
  Diamond,
  Square,
  Circle,
  Star,
};



// WEBPACK FOOTER //
// ./src/components/Icons/timelineMarkers.js